module.exports = __webpack_public_path__ + "static/media/term-article-image2.29d73cdb.jpg";